<div class="aca-admin aca-trash">
  <aca-page-header icon="delete_outline" [title]="'DMS.TRASH_PAGE.FB20E8' | translate" [subtitle]="'DMS.UI.F48D9D' | translate">
    <button type="button" class="aca-trash__outline" (click)="reload()" [disabled]="loading() || working()">
      <mat-icon>refresh</mat-icon>{{ 'DMS.TRASH_PAGE.78A47D' | translate }}
    </button>
  </aca-page-header>

  <!-- ── notice ─────────────────────────────────────────────────────────── -->
  <div class="aca-trash__notice" *ngIf="noticeOpen()">
    <mat-icon>info</mat-icon>
    <p>
      {{ 'DMS.TRASH_PAGE.57A141' | translate }}<strong>{{ 'DMS.TRASH_PAGE.76698C' | translate }}</strong
      >{{ 'DMS.TRASH_PAGE.319990' | translate }}
    </p>
    <button type="button" class="aca-trash__noticeclose" (click)="dismissNotice()" [attr.aria-label]="'DMS.TRASH_PAGE.3F2EAE' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ── toolbar ────────────────────────────────────────────────────────── -->
  <div class="aca-trash__toolbar">
    <div class="aca-trash__toolbarleft">
      <span class="aca-trash__selection">{{ 'DMS.UI.7B772E' | translate }} {{ selectedCount() }} {{ 'DMS.UI.4514CB' | translate }}</span>

      <button
        type="button"
        class="aca-trash__restore"
        data-automation-id="dms-trash-restore-selected"
        [disabled]="!selectedCount() || working()"
        (click)="restoreSelected()"
      >
        <mat-icon>restore</mat-icon>{{ 'DMS.TRASH_PAGE.8893EC' | translate }}
      </button>

      <button
        type="button"
        class="aca-trash__danger"
        data-automation-id="dms-trash-purge-selected"
        [disabled]="!selectedCount() || working()"
        (click)="purgeSelected()"
      >
        <mat-icon>delete_forever</mat-icon>{{ 'DMS.TRASH_PAGE.9778BF' | translate }}
      </button>

      <button
        type="button"
        class="aca-trash__danger"
        data-automation-id="dms-trash-purge-all"
        [disabled]="!total() || working()"
        (click)="purgeAll()"
      >
        <mat-icon>delete_sweep</mat-icon>{{ 'DMS.TRASH_PAGE.EMPTY_ALL' | translate }}
      </button>
    </div>

    <div class="aca-trash__toolbarright">
      <span class="aca-trash__count">{{ 'DMS.UI.BD5D57' | translate }} {{ total() | number }} {{ 'DMS.UI.4514CB' | translate }}</span>
      <label class="aca-trash__filter">
        <select class="aca-trash__select" [ngModel]="pageSize" (ngModelChange)="changePageSize($event)">
          <option *ngFor="let size of pageSizes" [value]="size">{{ size }} {{ 'DMS.UI.590B8F' | translate }}</option>
        </select>
      </label>
    </div>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading() || working()" />

  <aca-page-state
    *ngIf="failed()"
    state="error"
    [title]="'DMS.TRASH_PAGE.76BD1F' | translate"
    [message]="failed()"
    [actionLabel]="'DMS.UI.324E7E' | translate"
    (action)="reload()"
  />

  <aca-page-state
    *ngIf="!failed() && !loading() && !rows().length"
    state="empty"
    icon="delete_outline"
    [title]="'DMS.TRASH_PAGE.F10880' | translate"
    [message]="'DMS.UI.90F2C5' | translate"
  />

  <!-- ── table ──────────────────────────────────────────────────────────── -->
  <section class="aca-trash__card" *ngIf="!failed() && rows().length">
    <div class="aca-trash__tablewrap">
      <table class="aca-trash__table">
        <thead>
          <tr>
            <th class="aca-trash__th aca-trash__th--check">
              <mat-checkbox
                [checked]="allSelected()"
                [indeterminate]="someSelected()"
                (change)="toggleAll()"
                [attr.aria-label]="'DMS.TRASH_PAGE.D92662' | translate"
              />
            </th>
            <th class="aca-trash__th aca-trash__th--name">{{ 'DMS.TRASH_PAGE.85B482' | translate }}</th>
            <th class="aca-trash__th">{{ 'DMS.TRASH_PAGE.B54308' | translate }}</th>
            <th class="aca-trash__th">{{ 'DMS.TRASH_PAGE.54E580' | translate }}</th>
            <th class="aca-trash__th">{{ 'DMS.TRASH_PAGE.84BC5E' | translate }}</th>
            <th class="aca-trash__th">{{ 'DMS.TRASH_PAGE.FF4EF9' | translate }}</th>
            <th class="aca-trash__th aca-trash__th--actions">{{ 'DMS.TRASH_PAGE.6D5E7B' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="aca-trash__row"
            *ngFor="let row of rows(); trackBy: trackById"
            [class.aca-trash__row--on]="isSelected(row)"
            [attr.data-automation-id]="'dms-trash-row-' + row.name"
          >
            <td class="aca-trash__td aca-trash__td--check">
              <mat-checkbox
                [checked]="isSelected(row)"
                (change)="toggle(row)"
                [attr.aria-label]="('DMS.UI.B56AEE' | translate) + row.name"
                [attr.data-automation-id]="'dms-trash-select-' + row.name"
              />
            </td>

            <td class="aca-trash__td aca-trash__td--name">
              <span class="aca-trash__badge" [ngClass]="badgeClass(row)">
                <mat-icon *ngIf="row.isFolder">folder</mat-icon>
                <ng-container *ngIf="!row.isFolder">{{ badge(row) }}</ng-container>
              </span>
              <span class="aca-trash__namebox">
                <span class="aca-trash__name" data-automation-id="dms-trash-name">{{ row.name }}</span>
                <span class="aca-trash__size">{{ row.isFolder ? ('DMS.UI.848311' | translate) : formatSize(row.sizeInBytes) }}</span>
              </span>
            </td>

            <td class="aca-trash__td">{{ row.originalLocation || '—' }}</td>
            <td class="aca-trash__td">{{ row.deletedByName || '—' }}</td>
            <td class="aca-trash__td">{{ row.deletedAt | acaDate: 'd MMM y HH:mm' }}</td>
            <td class="aca-trash__td">
              <span class="aca-trash__chip">{{ ageText(row) }}</span>
            </td>

            <td class="aca-trash__td aca-trash__td--actions">
              <button
                mat-icon-button
                class="aca-trash__iconaction"
                (click)="restore(row)"
                [disabled]="working()"
                [matTooltip]="'DMS.TRASH_PAGE.15B475' | translate"
                [attr.aria-label]="'DMS.TRASH_PAGE.15B475' | translate"
              >
                <mat-icon>restore</mat-icon>
              </button>
              <button
                mat-icon-button
                class="aca-trash__iconaction aca-trash__iconaction--danger"
                (click)="purge(row)"
                [disabled]="working()"
                [matTooltip]="'DMS.TRASH_PAGE.9778BF' | translate"
                [attr.aria-label]="'DMS.TRASH_PAGE.9778BF' | translate"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="aca-trash__pager">
      <span class="aca-trash__range"
        >{{ 'DMS.UI.1D31FB' | translate }} {{ rangeStart | number }} {{ 'DMS.UI.D37F19' | translate }} {{ rangeEnd | number }}
        {{ 'DMS.UI.F2DB2C' | translate }} {{ total() | number }} {{ 'DMS.UI.4514CB' | translate }}</span
      >

      <div class="aca-trash__pages">
        <button type="button" class="aca-trash__iconbtn" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <button
          type="button"
          class="aca-trash__page"
          *ngFor="let page of pageNumbers"
          [class.aca-trash__page--on]="page === pageIndex"
          (click)="goToPage(page)"
        >
          {{ page + 1 }}
        </button>

        <button type="button" class="aca-trash__iconbtn" [disabled]="pageIndex >= pageCount - 1" (click)="goToPage(pageIndex + 1)">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </section>
</div>
